import { Button, Heading, Spinner, Text } from '@/ui';
import { ConsentCard } from './ConsentCard';
import { ConsentShell } from './ConsentShell';
import { useConsentRequest } from './useConsentRequest';

export const Connect = () => {
  const {
    data: request,
    isError,
    isFetching,
    isPending,
    refetch,
  } = useConsentRequest();

  if (isPending) {
    return (
      <ConsentShell>
        <Spinner alignSelf="center" data-testid="connect-loader" />
      </ConsentShell>
    );
  }

  // A dropped connection or a 500, which is not the same thing as an expired
  // request and must not be reported as one: the grant is probably still
  // sitting there, and telling someone to start over would throw away a request
  // that only needed the page loading again.
  if (isError) {
    return (
      <ConsentShell>
        <Heading as="h1" fontSize="2xl">
          We could not load this request
        </Heading>
        <Text color="ink.soft" fontSize="ah-row">
          Something went wrong reaching Agenda Hero. Your request is probably
          still waiting, so try again.
        </Text>
        <Button isLoading={isFetching} onClick={() => refetch()}>
          Try again
        </Button>
      </ConsentShell>
    );
  }

  // Expired, already answered, or arrived at directly. Nothing here is
  // recoverable from this page: the grant belongs to whoever started it.
  if (!request) {
    return (
      <ConsentShell>
        <Heading as="h1" fontSize="2xl">
          This request has expired
        </Heading>
        <Text color="ink.soft" fontSize="ah-row">
          Approvals are only good for a few minutes. Start the connection again
          from the app you were connecting.
        </Text>
      </ConsentShell>
    );
  }

  return (
    <ConsentShell>
      <ConsentCard request={request} />
    </ConsentShell>
  );
};
